// extracted by mini-css-extract-plugin
module.exports = {"mediaColumnWrapper":"_d5efaebf","mainMedia":"_8b24ca11"};